import { useEffect, useState } from 'react';
import { useLiveStats } from '../hooks/useApi';

function formatRelative(updatedAt?: string) {
  if (!updatedAt) return 'Never updated';

  const date = new Date(updatedAt);
  if (Number.isNaN(date.getTime())) return updatedAt;

  const diffMs = Date.now() - date.getTime();
  const absSeconds = Math.max(0, Math.floor(Math.abs(diffMs) / 1000));

  if (absSeconds < 5) return 'Updated just now';
  if (absSeconds < 60) return `Updated ${absSeconds}s ago`;

  const absMinutes = Math.floor(absSeconds / 60);
  if (absMinutes < 60) return `Updated ${absMinutes}m ago`;

  const absHours = Math.floor(absMinutes / 60);
  if (absHours < 24) return `Updated ${absHours}h ago`;

  return `Updated on ${date.toLocaleString()}`;
}

export default function LastUpdated() {
  const { data: live, dataUpdatedAt } = useLiveStats();
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1_000);
    return () => clearInterval(id);
  }, []);

  const label = formatRelative(live?.updatedAt ?? new Date(dataUpdatedAt).toISOString());

  return (
    <span className="text-xs text-[var(--muted)]" title={live?.updatedAt}>
      {label}
    </span>
  );
}
